import { useTranslation } from 'react-i18next'

import { Chip, Text } from '@reveni-io/reveni-ui'

import { getClaimStatusChip } from './helpers'

const ClaimStatusChip = ({ status }) => {
  const { t } = useTranslation()

  const statusChip = getClaimStatusChip()[status]

  if (!statusChip) return null

  return (
    <Chip
      label={
        <Text type="bodySMedium" color={statusChip.color}>
          {t(statusChip.label)}
        </Text>
      }
      Icon={statusChip.Icon}
      color={statusChip.color}
      backgroundColor={statusChip.backgroundColor}
    />
  )
}

export default ClaimStatusChip
